import RequestSender from './RequestSender.js';

function GetHasActiveSession() {
    return RequestSender.Get('authentication/GetHasActiveSession');
}

function Login(data) {
    return RequestSender.Get('authentication/Login', data);
}

function Logout() {
    return RequestSender.Post('authentication/Logout');
}

function SaveMFA(data) {
    return RequestSender.Get('authentication/SaveMFA', data);
}

function ValidateMFA(data) {
    return RequestSender.Get('authentication/ValidateMFA', data);
}

function ValidateInvitation(data) {
    return RequestSender.Get('authentication/ValidateInvitation', data);
}

function AddSecretKey(data){
    return RequestSender.Post('authentication/AddSecretKey', data);
}

function RemoveSecretKey(){
    return RequestSender.Post('authentication/RemoveSecretKey');
}

function RequestMfaRestore(){
    return RequestSender.Post('authentication/RequestMfaRestore');
}

function ResendSecurityCode(){
    return RequestSender.Post('authentication/ResendSecurityCode');
}

function ValidateSecurityCode(data){
    return RequestSender.Post('authentication/ValidateSecurityCode', data);
}

function ValidateInvitationByEmail(data){
    return RequestSender.Get('authentication/ValidateInvitationByEmail', data);
}

export default {
    ValidateInvitation, AddSecretKey, RemoveSecretKey, ValidateInvitationByEmail, ValidateMFA, SaveMFA, Logout,
    GetHasActiveSession, Login, RequestMfaRestore, ResendSecurityCode, ValidateSecurityCode
}